export const message = {
  language: 'English',
  home_nav: {
    nav_title_home: 'Home',
    nav_title_one: 'Company',
    nav_title_two: 'Product',
    nav_title_three: 'Case',
    nav_title_four: 'Solution',
    nav_title_five: 'Tutorial',
    nav_title_six: 'Contact',
    nav_title_seven: 'Download',
  },
  advantage: {
    title: '我们的优势',
    type: 'Our | advantage | Rapid | Low cost',
    info: `This is the content this is the content this is the content
     | This is the content this is the content this is the content
     | This is the content this is the content this is the content
     | This is the content this is the content this is the content
    `
  },
  products: {
    title: 'Our Products',
    type: {
      type1: '停线求助',
      type2: '故障报修',
      type3: '空转计时',
      type4: '班末总结',
      type5: '先进先出',
      type6: '预防性维护',
      type7: '合理化建议',
      type8: '更多功能'
    }
  },
  example: {
    title: 'Our Case'
  },
  caseMenu: {
    title: 'Case一 |Case二 |Case三 |Case四 |'
  },
  caseInfoList: [{
    index: 0,
    infoDesc: "ccc",
    infoSrc: "solution_hardware.png",
    solutionDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    solutionSrc: "solution_hardware.png",
    advantageDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    advantageSrc: "solution_hardware.png",
    valueDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    valueSrc: "solution_hardware.png",

  }, {
    index: 1,
    infoDesc: "案例2详细介绍",
    infoSrc: "solution_hardware.png",
    solutionDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    solutionSrc: "solution_hardware.png",
    advantageDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    advantageSrc: "solution_hardware.png",
    valueDesc: "汽车企业为了解决停车供需不平衡不充分以及人们普遍反映的泊车入库难找车难导致的停车矛盾，需要引入自动驾驶系统，该项目也是对城市服务智能化升级和新型商业模式的探索",
    valueSrc: "solution_hardware.png",

  }, ],
}



// WEBPACK FOOTER //
// ./src/assets/language/home/En-us.js